import { defineComponent as _defineComponent } from 'vue';
import MouldingResult from 'public/components/picture-frames/Tabs/MouldingOptions/MouldingResult.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MouldingOptions',
    props: {
        lengths: { default: () => [] },
        value: { default: () => null }
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        return { __sfc: true, props, emit, MouldingResult };
    }
});
